import ChargePointListView from '../../components/ChargePointListView';
import Global from 'general/utils/Global';

function ChargePointListScreen(props) {
    // ---- PROPERTIES ----
    return (
        <div className="container-fluid px-0 my-4">
            <ChargePointListView
                chargePointListFilter={Global.g_filterChargePointList}
            />
        </div>
    );
}

export default ChargePointListScreen;
